<template>
  <div>
    <div class="d-flex justify-space-between align-end mb-4">
      <h1 class="text-h4">Laufende Jobs</h1>
    </div>

    <v-alert v-if="showBackgroundWarning" type="warning" variant="tonal" class="mb-4">
      <div class="d-flex align-center ga-3">
        <div><strong>Geo::ImportBackgroundJob</strong> laeuft nicht.</div>
        <v-form method="post" :action="pageProps.start_background_job_path">
          <input type="hidden" name="authenticity_token" :value="pageProps.csrfToken">
          <v-btn size="small" type="submit" color="primary">Starten</v-btn>
        </v-form>
      </div>
    </v-alert>

    <v-card>
      <v-table>
        <thead>
          <tr>
            <th>Job-Klasse</th>
            <th class="text-right">Laufend</th>
            <th class="text-right">Queued</th>
            <th class="text-right">Fehler</th>
            <th class="text-right">Gesamt</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in sortedRows" :key="row.job_class">
            <td>{{ row.job_class }}</td>
            <td class="text-right">{{ row.running || 0 }}</td>
            <td class="text-right">{{ row.queued || 0 }}</td>
            <td class="text-right">{{ row.errors || 0 }}</td>
            <td class="text-right">{{ row.count || 0 }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { DelayedJobsChannel } from "../services/delayed-jobs-channel";

const props = defineProps({
  pageProps: {
    type: Object,
    required: true,
  },
});

const rows = ref([]);
let channel = null;

const sortedRows = computed(() => {
  return rows.value
    .slice()
    .sort((a, b) => (b.running || 0) - (a.running || 0) || (b.count || 0) - (a.count || 0) || a.job_class.localeCompare(b.job_class));
});

const showBackgroundWarning = computed(() => {
  return !rows.value.find((row) => row.job_class === "Geo::ImportBackgroundJob");
});

onMounted(() => {
  channel = new DelayedJobsChannel((payload) => {
    rows.value = payload;
  });
  channel.connect();
});

onBeforeUnmount(() => {
  channel?.channel?.unsubscribe();
});
</script>
